import { apiGet, apiPatch } from '@/lib/http/client';

import type {
  HubspotFieldMapping,
  HubspotFieldMappingsResponse,
} from '../types';

export type UpdateMappingBody = Partial<{
  ahoy_property: string | null;
  sync_direction: string;
  conflict_resolution: string | null;
}>;

export async function getHubspotFieldMappings(
  orgId: number | string
): Promise<HubspotFieldMappingsResponse> {
  return apiGet<HubspotFieldMappingsResponse>(
    `/api/orgs/${orgId}/hubspot/field-mappings/`
  );
}

export async function updateHubspotFieldMapping(
  orgId: number | string,
  mappingId: number,
  body: UpdateMappingBody
): Promise<HubspotFieldMapping> {
  return apiPatch<HubspotFieldMapping>(
    `/api/orgs/${orgId}/hubspot/field-mappings/${mappingId}/`,
    body
  );
}
